export function validatePhoneNumber(phoneNumber) {
	let cleaned = phoneNumber.replace(/\D/g, '');
	let re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
	return re.test(cleaned);
}

export function reformatPhoneString(phoneNumber) {
	let cleaned = ('' + phoneNumber).replace(/\D/g, '');
	let match = cleaned.match(/^(\d{3})(\d{3})(\d{4,6})$/);
	return '(' + match[1] + ') ' + match[2] + '-' + match[3];
}

export function reformatPhoneString2(phoneNumber) {
	let cleaned = ('' + phoneNumber).replace(/\D/g, '');
	let match = cleaned.match(/^(\d{3})(\d{3})(\d{4,6})$/);
	if (match) {
		return match[1] + '-' + match[2] + '-' + match[3];
	}
	return null;
}

export function removeAlphabeticalCharWithMaxLength(input) {
	// let cleaned = input.replace(/[a-zA-Z]/g, '');
	let cleaned = input.replace(/[^0-9_-]/g, '');
	let lengthReg = /^.{0,16}$/;
	return lengthReg.test(cleaned) ? cleaned : cleaned.substring(0, 16);
}
